import React from 'react';
import { Button, Col, FormInstance, Row, Typography } from 'components';
import {
  CloseIconLight,
  CopyIcon,
  EditIconLight,
  EmailIcon,
  FacebookIcon,
  FaxIcon,
  InstagramIcon,
  LandlineIcon,
  LinkedinIcon,
  MobileIcon,
  TelegramIcon,
  ViberIcon,
  WhatsAppIcon,
} from 'components/common/icons';
import { CopiedIcon } from 'components/common/icons/contactFieldManagerIcons/CopiedIcon';
import { ContactInfoCardDataType, ContactInfoFieldKeyType } from 'typings/form';
import { ContactInfoForm } from '../ContactInfoForm';
import styles from './styles.module.scss';
import { useContactInfoCard } from './useContactInfoCard';

const { Text } = Typography;

export const CONTACT_TYPES_MAPPING: Record<ContactInfoFieldKeyType, Record<'icon' | 'value', any>> = {
  EMAIL: {
    icon: <EmailIcon />,
    value: 'Email',
  },
  FAX: {
    icon: <FaxIcon />,
    value: 'Fax',
  },
  LANDLINE: {
    icon: <LandlineIcon />,
    value: 'Landline',
  },
  MOBILE: {
    icon: <MobileIcon />,
    value: 'Mobile',
  },
  INSTAGRAM: {
    icon: <InstagramIcon />,
    value: 'Instagram',
  },
  FACEBOOK: {
    icon: <FacebookIcon />,
    value: 'Facebook',
  },
  LINKED_IN: {
    icon: <LinkedinIcon />,
    value: 'Linkedin',
  },
  WHATS_APP: {
    icon: <WhatsAppIcon />,
    value: 'WhatsApp',
  },
  TELEGRAM: {
    icon: <TelegramIcon />,
    value: 'Telegram',
  },
  VIBER: {
    icon: <ViberIcon />,
    value: 'Viber',
  },
};

interface IContactInfoCard {
  data: ContactInfoCardDataType;
  form: FormInstance;
  onContactRowEdit: (id: string) => void;
  onContactRowRemove: (id: string) => void;
  onContactRowSave: (id?: string) => void;
  onContactRowStateChange: () => void;
  isEditeMode: boolean;
}

export const ContactInfoCard = (props: IContactInfoCard) => {
  const { data, form, onContactRowEdit, onContactRowRemove, onContactRowSave, onContactRowStateChange, isEditeMode } =
    props;
  const { onCopy, onEdit, copyStatus, editData } = useContactInfoCard({ onContactRowEdit });
  return (
    <>
      {!isEditeMode && (
        <Row className={styles.main} align={'middle'} justify={'space-between'}>
          <Col>
            <Row gutter={4} align={'middle'}>
              {CONTACT_TYPES_MAPPING[data.type].icon}
              <Col>
                <Text ellipsis={{ tooltip: true }} style={{ color: '#222530', maxWidth: 350 }}>
                  {data.value}
                </Text>
              </Col>
              <Col>
                <Row>
                  <Button type={'link'} onClick={() => onCopy(data.value)} size={'small'}>
                    {copyStatus[data.value] ? <CopiedIcon /> : <CopyIcon />}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row align={'middle'}>
              <Col>
                <Button
                  size={'small'}
                  type={'link'}
                  icon={<EditIconLight />}
                  onClick={() => {
                    onEdit(data);
                  }}
                />
              </Col>
              <Col>
                <Button
                  size={'small'}
                  type={'link'}
                  icon={<CloseIconLight />}
                  onClick={() => onContactRowRemove(data.id)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {isEditeMode && (
        <ContactInfoForm
          form={form}
          onCancel={onContactRowStateChange}
          onSave={onContactRowSave}
          dataToEdit={editData}
        />
      )}
    </>
  );
};
